module.exports = __webpack_public_path__ + "static/media/pic10@2x.4846b05d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_146/img/pic10@2x.png
// module id = 1403
// module chunks = 0